import store from "../store";
import { addToast } from "../actions/toastAction";
import axios from 'axios';
const defaultOptions = {
    color: "#6796e6"
  };
  let id = 0;
export  function createToast(options) {
   
    return {
      ...defaultOptions,
      ...options,
      id: id++
    }
  }
export function showToast(msg) {
    store.dispatch(addToast({ text: msg }));
  }
  export function downloadPDF(type ){
    
    
    var formdata = new FormData();
    var fileName = type+"_"+process.env.customer;
    formdata.append("documentType",fileName);
  
    axios.post(process.env.UAT_SCC +'/itrams/help',formdata,{
      //method: 'POST',
    responseType: 'blob' //Force to receive data in a Blob Format
  }).then(response => {
      const blob = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(blob);
      window.open(fileURL);
    })
    .catch(error=> {
      console.log("Error while fetching document from backend");
    });
      
     
  
  }